import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import _ from 'lodash';

const CssTextField = withStyles({
  root: {
    width: '100%',

    '& label.Mui-focused': {
      color: '#4F4F4F'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#00AAFC'
      }
    },
    '& .MuiFormHelperText-root': {
      color: 'red'
    }
  }
})(TextField);

export default React.memo(
  function OutlinedInput(props: TextFieldProps) {
    return <CssTextField {...props} margin="normal" variant="outlined" />;
  },
  (prevProps, nextProps) => _.isEqual(prevProps.value, nextProps.value) && _.isEqual(prevProps.error, nextProps.error)
);
